module.exports = __webpack_public_path__ + "static/img/Alex-Johnstone.ba7a062.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex-Johnstone.jpg
// module id = ToBv
// module chunks = 0